/*
 * Add to cart from inside the cart drawer.
 *
 * <product-form> cannot be used here. The rows this serves sit inside the
 * drawer's own <form id="CartDrawer-Form">, and an HTML parser drops a <form>
 * start tag that opens inside another one — the element is never created, so
 * product-form.js finds nothing to bind to and the button falls through to
 * submitting the cart form instead. This posts the line itself and needs no
 * form of its own, which is what lets the offers live among the cart lines.
 *
 * The variant comes from the select when the product has options and from the
 * element's own attribute when it does not.
 */
if (!customElements.get('cart-quick-add')) {
  customElements.define(
    'cart-quick-add',
    class CartQuickAdd extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('button');
        this.select = this.querySelector('select');
        this.spinner = this.querySelector('.loading__spinner');
        this.button.addEventListener('click', this.onClick.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      get variantId() {
        return this.select ? this.select.value : this.dataset.variantId;
      }

      onClick() {
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        this.spinner?.classList.remove('hidden');

        // Read while the elements are still in the DOM: renderContents replaces
        // the drawer's contents, and this element goes with them.
        const cart = this.cart;
        const sections = cart ? cart.getSectionsToRender().map((section) => section.id) : [];

        fetch(routes.cart_add_url, {
          ...fetchConfig('javascript'),
          body: JSON.stringify({
            items: [{ id: this.variantId, quantity: 1 }],
            sections,
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((state) => {
            // The cart answers a refusal with 200 and a status in the body, so
            // response.ok says nothing here.
            if (state.status) throw new Error(state.description || state.message);
            if (!cart) return;

            // Adding always leaves the cart with something in it, whatever the
            // drawer looked like a moment ago.
            cart.classList.remove('is-empty');
            cart.renderContents(state);
          })
          .catch((error) => {
            console.error(error);

            this.button.removeAttribute('aria-disabled');
            this.button.classList.remove('loading');
            this.spinner?.classList.add('hidden');
          });
      }
    }
  );
}
